<template>
  <div
    :class="{ grid: games?.length <= 4 }"
    class="market-sidebar__games"
  >
    <Swiper
      v-if="games?.length > 4"
      :grab-cursor="true"
      :loop="false"
      :slides-per-view="4.2"
      :space-between="12"
      class="games-swiper carousel"
    >
      <SwiperSlide
        v-for="game in games"
        :key="game?.name"
      >
        <div
          v-tooltip="game?.name || ''"
          class="game"
        >
          <img
            :alt="game?.name"
            :src="getImageFromProxy(`${imagesUrl}games/${game.logo}.png`, '300:200')"
          >
        </div>
      </SwiperSlide>
    </Swiper>
    <template v-else>
      <div
        v-for="game in games"
        :key="game?.name"
        v-tooltip="game?.name || ''"
        class="game"
      >
        <img
          :alt="game?.name"
          :src="getImageFromProxy(`${imagesUrl}games/${game.logo}.png`, '300:200')"
        >
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { MarketFullInfoSupportedGame } from '~/graphql/generated/schema-types';
import 'swiper/swiper-bundle.css';

defineProps<{
  games: MarketFullInfoSupportedGame[]
}>();
const Swiper = defineAsyncComponent(() => import('swiper/vue').then(m => m.Swiper));
const SwiperSlide = defineAsyncComponent(() => import('swiper/vue').then(m => m.SwiperSlide));

const config = useRuntimeConfig();
const imagesUrl = config.public.imagesUrl;
</script>

<style lang="scss" scoped>
@use "/assets/scss/components/carousel";

.market-sidebar__games {
  margin-top: 20px;

  &.grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
  }

  .games-swiper.carousel {
    min-height: unset;
  }

  .game {
    img {
      height: 88px;
      object-fit: cover;
      object-position: center;
      border-radius: 8px;
    }
  }

  @media screen and (max-width: 850px) {
    margin-top: 8px;
  }
}
</style>
